module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mt-radio-button",
    class: _vm.type ? ("mt-radio-button--" + _vm.type) : ''
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "id": _vm.id,
      "name": _vm.type,
      "disabled": _vm.disabled
    },
    domProps: {
      "checked": _vm.checked
    },
    on: {
      "click": _vm.handleClick,
      "change": _vm.handleChange
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": _vm.id
    }
  }, [_c('span', {
    staticClass: "line"
  }), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._t("default"), _vm._v(" "), (!_vm.$slots.default) ? [_vm._v(_vm._s(_vm.label))] : _vm._e()], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7afecc16","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/plugins/mtui/radio-button/RadioButton.vue
// module id = JuED
// module chunks = 0